import { Section, withHighlight } from "@/components/ui";
import { ABOUT_HERO } from "@/data/about";

/** About hero: the page's only H1 and one line of intro, centred. */
export function AboutHero() {
  return (
    <Section tone="brandTint" labelledBy="about-title" testId="about-hero" spacing="roomy" width="narrow">
      <div className="relative z-10 text-center">
        <h1
          id="about-title"
          className="font-heading text-5xl font-bold leading-[1.02] [text-wrap:balance] sm:text-6xl lg:text-7xl"
        >
          {withHighlight(ABOUT_HERO.title, ABOUT_HERO.highlight)}
        </h1>
        <p className="mx-auto mt-5 max-w-[48ch] text-lg text-ink/70 [text-wrap:balance] sm:text-xl">
          {ABOUT_HERO.introLines.map((line) => (
            <span key={line} className="block">
              {line}
            </span>
          ))}
        </p>
      </div>
    </Section>
  );
}
